<template>
  <section class="sky-done">
    <header>
      <div class="title">
        <h1>{{ $route.params.type | typeLabel }} saved successfully!</h1>
      </div>
    </header>
    <div class="buttons">
      <router-link :to="`/sky/${$route.params.type}`" class="alt-btn" tag="button">{{ $t('buttons.done') }}</router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'upload-done',
  filters: {
    typeLabel(type) {
      const camel = type.replace(/-([a-z])/g, function (g) { return ' ' + g[1].toUpperCase(); });
      return camel[0].toUpperCase() + camel.substr(1)
    }
  },
}
</script>
